import TextArea from "../../../../lib/ui/controls/TextArea";
import { BigNisButton } from "../BigNisButton";
import { FormModal } from "../../../../lib/ui/controls/FormModal";
import { util } from "../../../../lib/util/util";
import lodash from "lodash";
import { ImageDetect } from "alt1";
var selectFile = util.selectFile;
export class ImportModal extends FormModal {
    constructor(acceptedFiles = undefined, data_preprocessor, data_processor, handler = () => true, can_be_text = true) {
        super();
        this.acceptedFiles = acceptedFiles;
        this.data_preprocessor = data_preprocessor;
        this.data_processor = data_processor;
        this.handler = handler;
        this.can_be_text = can_be_text;
    }
    async commit(value) {
        const pre_processed = await this.data_preprocessor(value);
        if (!pre_processed)
            return;
        const processed = this.data_processor(pre_processed);
        if ((await this.handler(processed)) ?? true)
            this.confirm({ imported: processed });
    }
    render() {
        super.render();
        this.title.set("Import");
        const area = c()
            .css2({
            "position": "relative",
            "width": "100%",
            "height": "20em"
        })
            .appendTo(this.body);
        if (this.can_be_text) {
            this.textarea = new TextArea({ placeholder: "Paste text or drop file here" })
                .css2({
                "position": "relative",
                "resize": "none",
                "width": "100%",
                "height": "100%",
                "word-break": "break-all"
            })
                .on("paste", e => {
                const event = e.originalEvent;
                e.preventDefault();
                e.stopPropagation();
                const clipboardData = event.clipboardData;
                if (clipboardData.files?.length > 0) {
                    this.commit(clipboardData.files[0]);
                }
                else {
                    this.commit(clipboardData.getData('Text'));
                }
            })
                .on("drop", (e) => {
                e.preventDefault();
                if (e.originalEvent.dataTransfer.files.length > 0) {
                    this.commit(e.originalEvent.dataTransfer.files[0]);
                }
            })
                .appendTo(area);
            this.textarea.onChange(v => {
                this.import_button.setEnabled(!!v.value);
            });
        }
        if (this.acceptedFiles) {
            c().css2({
                "position": "absolute",
                "top": "9em",
                "left": 0,
                "right": 0,
                "text-align": "center",
                "z-index": 1,
                "cursor": "pointer"
            }).text("Click here to select file.")
                .on("click", async () => {
                const file = await selectFile(this.acceptedFiles);
                if (file)
                    this.commit(file);
            })
                .appendTo(area);
        }
    }
    getButtons() {
        return [
            new BigNisButton("Cancel", "cancel").onClick(() => this.confirm(null)),
            this.import_button = new BigNisButton("Import", "confirm")
                .setEnabled(false)
                .onClick(() => {
                this.commit(this.textarea.get());
            })
        ];
    }
    static textFile(parser, handler = () => true, accept = "text/*") {
        return new ImportModal(accept, ImportModal.preprocess_to_string, parser, handler).show();
    }
    static json(parser = lodash.identity, handler = () => true) {
        return new ImportModal("application/json,.txt", async (data) => {
            const s = await ImportModal.preprocess_to_string(data);
            return JSON.parse(s);
        }, parser, handler).show();
    }
    static img(handler) {
        return new ImportModal("image/png", async (data) => await ImageDetect.imageDataFromUrl(URL.createObjectURL(data)), x => x, handler, false).show();
    }
}
(function (ImportModal) {
    async function preprocess_to_string(data) {
        if (data instanceof File) {
            return new Promise(resolve => {
                const reader = new FileReader();
                reader.readAsText(data);
                reader.addEventListener("load", (e) => {
                    resolve(reader.result);
                });
            });
        }
        else
            return data;
    }
    ImportModal.preprocess_to_string = preprocess_to_string;
})(ImportModal || (ImportModal = {}));
